import { SCROLL_TO_ERROR_TIMEOUT } from '../constants';

export interface ServerError {
  status: number;
  response: {
    data: Record<string, string[]>;
  };
}

export const scrollToFirstError = () => {
  setTimeout(() => {
    const firstErrorField = document.querySelector('[data-error]');
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, SCROLL_TO_ERROR_TIMEOUT);
};

export const handleServerError = <T extends string>(
  err: ServerError,
  setError: (name: T, error: { type: string; message: string }) => void,
  onError: () => void
) => {
  if (err.status === 422) {
    Object.entries(err.response.data).forEach(([field, messages]) => {
      setError(field as T, { type: 'server', message: messages[0] });
    });
    onError();
  }
};
